(function () {
    'use strict';

    angular.module('NaviaqWebApp').constant('administrationSections', [
        { index: 0, titleKey: 'ADMIN_LOGACTION_TITLE', state: 'administration.logActions' },
        { index: 1, titleKey: 'ADMIN_VESSEL_TITLE', state: 'administration.vessels' },
        { index: 3, titleKey: 'ADMIN_ROLE_TITLE', state: 'administration.role' },
        { index: 4, titleKey: 'ADMIN_DAYCOUNTER_TITLE', state: 'administration.dayCounter', permission: 'UserAdministrationView' },
        { index: 5, titleKey: 'ADMIN_CUSTOMERS_TITLE', state: 'administration.customers' },
        { index: 8, titleKey: 'ADMIN_PERSONS_TITLE', state: 'administration.persons' },
        { index: 9, titleKey: 'ADMIN_LANDBASES_TITLE', state: 'administration.landbases' },
        { index: 10, titleKey: 'ADMIN_DOCUMENT_TYPES_TITLE', state: 'administration.documentTypes' },
        { index: 11, titleKey: 'ADMIN_LISTS_TITLE', state: 'administration.lists' },
        { index: 12, titleKey: 'ORDER_PROCESS_TITLE', state: 'administration.orderProcess' },
        { index: 13, titleKey: 'LOGACTIONPAIRS_TAB_NAME', state: 'administration.logActionPairs' },
        { index: 14, titleKey: 'ADMIN_JOB_TITLE_TITLE', state: 'administration.jobTitle' },
        { index: 15, titleKey: 'ADMIN_CONTRACTOR_TITLE', state: 'administration.contractor', superuserOnly: true },
        { index: 16, titleKey: 'ADMIN_NAV_TAGS_TITLE', state: 'administration.tags', permission: 'TagAdmin' },
        { index: 17, titleKey: 'ADMIN_LOCATION_SETTING_TAB_LOCATION_SHARING_TITLE', state: 'administration.locationSharing' }
    ]);
})();
